import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { postRequest, getRequest } from '../../../../lib/api';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../../authContext/context';
import { useDispatch } from 'react-redux';
import {addGroupCode} from '../../../../redux/slices/groupCodeSlice'
import TextField from '@mui/material/TextField';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'

export default function CreateGroupCode() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      tags: []
    }
  });

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [tagList, setTagList] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const res = await postRequest('private/fetchTagList', {}, authCtx.token);
        console.log(res , 'Response---0d0idh')
        if (res?.status === 200) {
          setTagList(res?.data || []);
        } else {
          toast.error(res?.message || 'Failed to fetch tags');
        }
      } catch (error) {
        toast.error('Error fetching tags');
      }
    };
    fetchTags();
  }, []);

  const handleTagSelection = (e) => {
    const options = e.target.options;
    const selected = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selected.push(options[i].value);
      }
    }
    setSelectedTags(selected);
    setValue('tags', selected);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        code: data?.code,
        name: data?.name,
        tags: data?.tags || [],
        isActive,
      };

      const response = await postRequest('private/createGroupCode', payload, authCtx.token);
      if (response?.status === 200) {
        dispatch(addGroupCode(response?.data))
        reset();
       // toast.success('Group code created successfully!');
        navigate('/groupCodes');
      } else {
       // toast.error(response?.message || 'API key creation failed');
      }
    } catch (err) {
      //toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
         <BreadcrumbsWrapper
                                                    items={[
                                                      { label: 'Dashboard', path: '/dashboard' },
                                                      { label: 'GroupCodes', path: '/groupCodes' },
                                                      { label: 'CreateGroupCode', path: '' },
                                                    
                                                     
                                                    ]}
                                                  />
                                            <br></br>
      <div className="page-header pb-3">
        <h1 className="mt-0 mb-0">Add New Group Code</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">

           <Form.Group as={Col} controlId="name">
              <Form.Label>Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter code"
                {...register('code', { required: 'Code is required' })}
                isInvalid={!!errors.code}
              />
              <Form.Control.Feedback type="invalid">
                {errors.code?.message}
              </Form.Control.Feedback>
            </Form.Group>

            {/* <Form.Group as={Col} controlId="code">
               <TextField id="outlined-basic" label="Enter code" variant="outlined" 
                 {...register('code', { required: 'Code is required' })}
                isInvalid={!!errors.code}
               />
            
              <Form.Control.Feedback type="invalid">
                {errors.code?.message}
              </Form.Control.Feedback>
            </Form.Group> */}

            <Form.Group as={Col} controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                {...register('name', { required: 'Name is required' })}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="tags">
              <Form.Label>Select Tags</Form.Label>
              <Form.Select
                multiple
                value={selectedTags}
                onChange={handleTagSelection}
                size={Math.min(tagList.length, 10)} // Show up to 10 options at once
              >
                {tagList?.map((tag, idx) => (
                 <option key={idx} value={tag._id}>
  {tag.name}
</option>

                ))}
              </Form.Select>
              {/* <Form.Text className="text-muted">
                Hold Ctrl/Cmd to select multiple tags
              </Form.Text> */}
            </Form.Group>
          </Row>

          <Form.Group className="mb-3" controlId="isActive">
            <Form.Check
              type="checkbox"
              label="Is Active"
              checked={isActive}
              onChange={() => setIsActive((prev) => !prev)}
            />
          </Form.Group>

          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/groupCodes')}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}